import React from "react";
import {
	BsCheckCircle,
	BsCloudUpload,
	BsFileText,
} from "react-icons/bs";

const STEPS = [
	{
		id: 1,
		label: "Prepare",
		short: "Prep",
		hint: "Column format",
		Icon: BsFileText,
	},
	{
		id: 2,
		label: "Upload",
		short: "Upload",
		hint: "Excel or CSV",
		Icon: BsCloudUpload,
	},
	{
		id: 3,
		label: "Complete",
		short: "Done",
		hint: "Download result",
		Icon: BsCheckCircle,
	},
];

/**
 * Visual progress for the metadata import wizard.
 * @param {number} current - 1..3
 */
const WizardStepper = ({ current = 1 }) => {
	return (
		<nav aria-label="Upload books progress" className="w-full">
			<ol className="flex items-start justify-between gap-1">
				{STEPS.map((step, index) => {
					const done = current > step.id;
					const active = current === step.id;
					const upcoming = current < step.id;
					const Icon = step.Icon;

					return (
						<li
							key={step.id}
							className="relative flex flex-1 flex-col items-center text-center"
						>
							{index > 0 ? (
								<span
									aria-hidden="true"
									className={`absolute left-0 top-5 -z-0 h-0.5 w-full transition-colors duration-300 ${
										done || active ? "bg-akgreen" : "bg-gray-200"
									}`}
									style={{ width: "100%", left: "-50%" }}
								/>
							) : null}
							<span
								className={`relative z-10 flex h-10 w-10 items-center justify-center rounded-full text-sm font-semibold transition-all duration-300 ${
									done
										? "bg-akgreen text-white shadow-sm"
										: active
										? "bg-akgreen text-white shadow-md ring-2 ring-akgreen"
										: "bg-gray-100 text-gray-500"
								}`}
								aria-current={active ? "step" : undefined}
							>
								{done ? (
									<BsCheckCircle className="h-5 w-5" aria-hidden />
								) : (
									<Icon className="h-4 w-4" aria-hidden />
								)}
							</span>
							<span
								className={`mt-2.5 hidden text-xs font-semibold sm:block ${
									active
										? "text-akgreenest"
										: upcoming
										? "text-gray-400"
										: "text-gray-700"
								}`}
							>
								{step.label}
							</span>
							{active ? (
								<span className="mt-0.5 hidden text-xs text-gray-500 sm:block">
									{step.hint}
								</span>
							) : null}
							<span
								className={`mt-1.5 text-xs sm:hidden ${
									active
										? "font-semibold text-akgreenest"
										: "text-gray-500"
								}`}
							>
								{step.short}
							</span>
						</li>
					);
				})}
			</ol>
		</nav>
	);
};

export default WizardStepper;
